import { render, staticRenderFns } from "./CreateDiscussionForum.vue?vue&type=template&id=e3e16484&"
import script from "./CreateDiscussionForum.vue?vue&type=script&lang=js&"
export * from "./CreateDiscussionForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports